import type { Timestamp } from 'firebase/firestore';

export type FacilitatorContractStatus = 'sent' | 'signed';

export type FacilitatorContractTemplate = {
  id: string;
  organisationId: string;
  title: string;
  bodyMarkdown: string;
  createdAt: Timestamp;
  updatedAt: Timestamp;
  createdByUserId: string;
  /** Budget tracker id this agreement belongs to. */
  projectId?: string;
  /** Display name from the budget tracker / project timeline. */
  projectName?: string;
};

export type FacilitatorContractTemplateInput = {
  organisationId: string;
  title: string;
  bodyMarkdown: string;
  createdByUserId: string;
  projectId?: string;
  projectName?: string;
};

export type FacilitatorContract = {
  id: string;
  organisationId: string;
  templateId: string;
  title: string;
  bodyMarkdown: string;
  status: FacilitatorContractStatus;
  recipientName: string;
  recipientEmail: string;
  facilitatorId: string;
  companySignatoryName: string;
  companySignatoryPosition: string;
  companySignedAt: Timestamp;
  signerFullName: string;
  signerAddress: string;
  signerPhone: string;
  signerEmail: string;
  signerSignature: string;
  signedAt?: Timestamp;
  agreed: boolean;
  createdAt: Timestamp;
  updatedAt: Timestamp;
  sentByUserId: string;
  projectId?: string;
  projectName?: string;
};

export type FacilitatorContractCreateInput = {
  organisationId: string;
  templateId: string;
  title: string;
  bodyMarkdown: string;
  recipientName: string;
  recipientEmail: string;
  facilitatorId: string;
  companySignatoryName: string;
  companySignatoryPosition: string;
  sentByUserId: string;
  projectId?: string;
  projectName?: string;
};

export type FacilitatorContractSignInput = {
  signerFullName: string;
  signerAddress: string;
  signerPhone: string;
  signerEmail: string;
  signerSignature: string;
  agreed: boolean;
};

export const FACILITATOR_CONTRACT_FIELD_LIMITS = {
  title: 200,
  recipientName: 120,
  recipientEmail: 254,
  companySignatoryName: 120,
  companySignatoryPosition: 120,
  signerFullName: 120,
  signerAddress: 500,
  signerPhone: 40,
  signerEmail: 254,
  signerSignature: 120,
  bodyMarkdown: 80000,
  personalNote: 1000,
  projectId: 80,
  projectName: 200,
};
